import { FieldName, FilterOperationEnum, FilterType, getDateEndOfDay } from "@simplyk/common";

import { removeFromLocalStorage } from "@/common/helpers/localStorage";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { DashboardFilter, FilterInput } from "@/components/Filters/type";

export interface TableParametersInput {
  filters: Array<Array<FilterInput>>;
  limit: number;
  cursor: number;
}

export const getFiltersParameters = (
  cursor: number,
  limit: number,
  allFilters: DashboardFilter[],
  searchFilter: DashboardFilter[] = []
): TableParametersInput => {
  const filters: DashboardFilter[][] = allFilters.map((filter) => [
    {
      type: filter.type,
      operation: filter.operation,
      fieldName: filter.fieldName,
      values: filter.values,
      hidden: filter.hidden,
    },
  ]) || [[]];
  ``;

  return {
    cursor,
    limit,
    filters: serializeFilterToFilterInput([...filters, searchFilter]),
  };
};

export const getBulkFilter = (fieldName: FieldName, values: string[], remove: boolean): FilterInput[] => {
  const bulkFilter = {
    type: FilterType.Multiselect,
    operation: remove ? FilterOperationEnum.NotIn : FilterOperationEnum.In,
    fieldName,
    values,
  };
  return [bulkFilter];
};

export interface DefaultContactPageFilters {
  searchFilters?: DashboardFilter[];
  activeFilters?: DashboardFilter[];
  bulkFilters?: DashboardFilter;
}

export interface DefaultPaymentPageFilters {
  searchFilters?: DashboardFilter[];
  activeFilters?: DashboardFilter[];
  formFilters?: DashboardFilter[];
}

export const serializeFilterToDefaultContactParameter = (
  defaultFilters:
    | { activeFilters?: DashboardFilter[] | undefined; searchFilters?: DashboardFilter[] | undefined }
    | undefined,
  rowsPerPage: number
) => {
  const activeDefaultFilters = defaultFilters?.activeFilters?.map((filter) => [filter]) || [];
  const searchDefaultFilters = defaultFilters?.searchFilters || [];

  const baseFilter = [searchDefaultFilters, ...activeDefaultFilters];
  return {
    offset: 0,
    limit: rowsPerPage,
    filters: baseFilter ? serializeFilterToFilterInput(baseFilter) : [[]],
  };
};

export const serializeFilterToFilterInput = (filters: DashboardFilter[][]): FilterInput[][] => {
  return filters.map((filterArray) =>
    filterArray.map((filter) => ({
      type: filter.type,
      fieldName: filter.fieldName,
      operation: filter.operation,
      values: filter.values,
      hidden: filter.hidden,
    }))
  );
};

export interface ReceiptFilters {
  startDate: string | undefined;
  endDate: string | undefined;
  search: string | undefined;
}

const toUTCDate = (dateStr: string) => {
  const date = new Date(dateStr);
  return new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds())
  );
};

export const getReceiptFilters = (storageDefaultFilters: ReceiptFilters): FilterInput[][] => {
  const { startDate, endDate, search } = storageDefaultFilters;
  const startDateFilter = startDate &&
    endDate && [
      {
        fieldName: FieldName.ReceiptTableDonationDate,
        operation: FilterOperationEnum.DateRange,
        type: FilterType.Date,
        values: [toUTCDate(startDate).toString(), toUTCDate(getDateEndOfDay(new Date(endDate)).toString()).toString()],
      },
    ];

  const searchFilter = search && [
    {
      fieldName: FieldName.ReceiptTableFirstName,
      operation: FilterOperationEnum.Contains,
      type: FilterType.String,
      values: [search],
    },
    {
      fieldName: FieldName.ReceiptTableLastName,
      operation: FilterOperationEnum.Contains,
      type: FilterType.String,
      values: [search],
    },
    {
      fieldName: FieldName.ReceiptTableEmail,
      operation: FilterOperationEnum.Contains,
      type: FilterType.String,
      values: [search],
    },
  ];

  const filters = [startDateFilter, searchFilter].filter((value) => value && value?.length > 0);
  return filters as FilterInput[][];
};

export const clearStoredFilters = () => {
  removeFromLocalStorage?.("orderTableFilters");
};
